// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".value-number[data-v-e2624f1e]{width:20px;height:20px;display:flex;align-items:center;justify-content:center;background:var(--v-primary-base);border-radius:50%;color:#fff;margin-left:8px;font-size:12px;font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
